export default {
    title: 'Create company-micro-trend',
    feedback: {
        success: 'The Company-micro-trend "{title}" was saved successfully.'
    }
}
